import React from 'react';
import { Box, Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Fab } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const TERMS = [
  { term: 'Forex / FX', definition: 'Foreign Exchange. The global market for trading one currency for another.' },
  { term: 'Currency pair', definition: 'A quotation of two currencies, e.g., EUR/USD. The first is the base currency and the second is the quote currency.' },
  { term: 'Spread', definition: 'The difference between the bid (sell) and ask (buy) price. Represents transaction cost/liquidity.' },
  { term: 'Stop loss', definition: 'A predefined price level where a trade automatically closes to limit losses.' },
  { term: 'Take profit', definition: 'A predefined price level where a trade automatically closes to lock in profit.' },
  { term: 'PIPs', definition: '“Percentage in point.” The standard unit of price movement. For most pairs, 1 pip = 0.0001.' },
  { term: 'Candlestick charts', definition: 'Chart type showing open, high, low, and close for a time period. Body shows open-close; wicks show extremes.' }
];

export default function Glossary() {
  const navigate = useNavigate();
  return (
    <Box sx={{ position: 'relative' }}>
      <Fab color="primary" aria-label="Back to Practice" onClick={() => navigate('/')} sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1500 }}>
        <ArrowBackIcon />
      </Fab>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h2" gutterBottom>Trade-vue glossary</Typography>
          <Typography variant="body1" color="text.secondary">Common trading terms used throughout the app.</Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table aria-label="glossary table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, width: '30%' }}>Term</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Definition</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {TERMS.map((row) => (
                <TableRow key={row.term}>
                  <TableCell component="th" scope="row">{row.term}</TableCell>
                  <TableCell>{row.definition}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </Box>
  );
}


